import React, { useEffect, useRef } from 'react';
import { Field, useForm } from '@/Framework/UI/Organisms/FinalForm';
import { IRequestServiceData } from './IRequestServiceData';
import EmailInput from '@/finsight/ui/common/components/EmailInput';
import Input from '@dealroadshow/uikit/core/components/Input';
import PhoneInput from '@dealroadshow/uikit/core/components/Input/PhoneInput';
import Textarea from '@dealroadshow/uikit/core/components/Textarea';
import ReCaptcha from '@/Framework/UI/Molecules/Form/ReCaptcha';
import ReCaptchaPolicy from '@/Framework/UI/Molecules/Form/ReCaptcha/ReCaptchaPolicy';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import { useRequestServiceModalContext } from '@/finsight/application/RequestServiceModalContext';

import recaptchaStyles from '@/Framework/UI/Molecules/Form/ReCaptcha/recaptcha.scss';
import styles from './styles.scss';

const RequestServiceFields = () => {
  const form = useForm<IRequestServiceData, Partial<IRequestServiceData>>();
  const { invalid } = form.getState();
  const {
    setRecaptchaObject,
    isFetching,
    titleForm,
    isCaptcha,
  } = useRequestServiceModalContext();
  const recaptchaRef = useRef<ReCaptcha>();

  useEffect(() => {
    if (isCaptcha && recaptchaRef.current) {
      setRecaptchaObject(recaptchaRef.current.recaptchaRef.current);
    }
  }, [recaptchaRef]);

  return (
    <div className={ styles.modalContainer }>
      <div className={ styles.modalHeader }>
        <h1>{ titleForm }</h1>
      </div>
      <div className={ styles.modalBody }>
        <div className={ styles.modalRow }>
          <Field
            component={ Input }
            name="firstName"
            label="First Name"
            placeholder="First Name"
            dataTest="requestServiceModalFirstName"
            formFieldClassName={ styles.modalField }
          />
          <Field
            component={ Input }
            name="lastName"
            label="Last Name"
            placeholder="Last Name"
            dataTest="requestServiceModalLastName"
            formFieldClassName={ styles.modalField }
          />
        </div>
        <div className={ styles.modalRow }>
          <Field
            component={ Input }
            name="companyName"
            label="Company Name"
            placeholder="Company Name"
            dataTest="requestServiceModalCompanyName"
            formFieldClassName={ styles.fullWidthModalField }
          />
        </div>
        <div className={ styles.modalRow }>
          <Field
            name="email"
            type="email"
            placeholder="Corporate Email"
            label="Corporate Email"
            component={ EmailInput }
            dataTest="requestServiceModalEmail"
            formFieldClassName={ styles.modalField }
          />
          <Field
            component={ PhoneInput }
            name="phone"
            label="Phone"
            isFinalForm
            dataTest="requestServiceModalPhone"
            formFieldClassName={ styles.modalField }
          />
        </div>
        <div className={ styles.modalRow }>
          <Field
            name="comment"
            placeholder="Please provide additional details if applicable..."
            label="Comment"
            component={ Textarea }
            dataTest="requestServiceModalComment"
            formFieldClassName={ styles.fullWidthModalField }
            textareaClassName={ styles.modalFieldComment }
          />
        </div>
      </div>

      <div className={ styles.modalFooter }>
        {
          isCaptcha && (
            <Field
              name="recaptcha"
              component={ ReCaptcha }
              dataTest="requestServiceModalRecaptcha"
              visible={ false }
              className={ recaptchaStyles.recaptchaHidden }
              formFieldClassName={ styles.modalRecaptchaField }
              ref={ recaptchaRef }
            />
          )
        }
        <Button
          type="submit"
          variant={ ButtonVariantType.action }
          dataTest="requestServiceModalSubmitButton"
          className={ styles.modalSubmitButton }
          disabled={ invalid || isFetching }
        >
          Submit Request
        </Button>
        { isCaptcha && <ReCaptchaPolicy /> }
      </div>
    </div>
  );
};

export default RequestServiceFields;
